<!-- 查询车辆信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
          requestBody: {
            "billCodeList": [
              "12312313"
            ],
            "parkCode":"2KDKISDD"
          },
            responseCode: {
                "data": {
                    "currCount": 1,
                    "recordList": [
                      {
                        "bills": [
                          {
                            "invoiceTitle": "测试开票",
                            "invoiceBillCode": "2022311222929",
                            "invoiceNumber": "12312",
                            "invoiceCode": "12312",
                            "invoiceBillType": "1",
                            "invoiceTitleType": "1",
                            "invoiceSerial": "12312",
                            "invoiceValue": "12312",
                            "invoiceTaxRatio": "12312",
                            "invoiceStatus": "12312",
                            "billingTime": "12312",
                            "billingPhone": "12312",
                            "invoiceFilePath": "12312",
                            "invoiceImgFilePath": "12312",
                          }
                        ],
                      },
                    ],
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,获取账单开票状态详情",
                t_url: this.commonUrls.test+"getInvoiceStatusDetail",
                p_url: this.commonUrls.prod+"getInvoiceStatusDetail",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'billCodeList', info2: '是', info3: 'JSONArray', info4: '账单列表' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '账单信息列表' },
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'invoiceTitle', info2: '是', info3: 'String', info4: '发票抬头' },
                      { info1: 'invoiceBillCode', info2: '是', info3: 'String', info4: '发票流水号' },
                      { info1: 'invoiceNumber', info2: '是', info3: 'String', info4: '发票号码' },
                      { info1: 'invoiceCode', info2: '是', info3: 'String', info4: '发票代码' },
                      { info1: 'invoiceBillType', info2: '是', info3: 'String', info4: '发票类型 0 blue蓝票,1 red红票' },
                      { info1: 'invoiceTitleType', info2: '是', info3: 'Integer', info4: '发票抬头类型 0 person个人,1 company公司' },
                      { info1: 'invoiceSerial', info2: '是', info3: 'String', info4: '纳税人识别号' },
                      { info1: 'invoiceValue', info2: '是', info3: 'String', info4: '开票金额' },
                      { info1: 'invoiceTaxRatio', info2: '否', info3: 'String', info4: '税率' },
                      { info1: 'invoiceStatus', info2: '是', info3: 'Integer', info4: '开票状态 0开票中,1已开票,2冲红,3作废,4失败' },
                      { info1: 'billingTime', info2: '是', info3: 'String', info4: '开票时间' },
                      { info1: 'billingPhone', info2: '是', info3: 'String', info4: '开票手机号码' },
                      { info1: 'invoiceFilePath', info2: '是', info3: 'String', info4: '发票pdf地址' },
                      { info1: 'invoiceImgFilePath', info2: '是', info3: 'String', info4: '发票图片地址' },
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getInvoiceStatusDetail.vue